import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { prepareSearchParams } from '@/libs/helper'

const resource = `${Config.basePath}/v1/api/admin/jackpot`

export default {
  index(payload) {
    let params = prepareSearchParams(payload)
    params = {
      ...payload,
      ...params,
    }
    if (payload.startDate) {
      params.filters.push({
        searchby: 'created_at',
        searchoperator: '>',
        search: `${payload.startDate} 00:00:00`,
      })
    }
    if (payload.toDate) {
      params.filters.push({
        searchby: 'created_at',
        searchoperator: '<',
        search: `${payload.toDate} 23:59:59`,
      })
    }
    return Client.post(resource, params, {
      headers: {
        action: 'list-win',
      },
    })
  },
  total(payload) {
    let params = prepareSearchParams(payload)
    params = {
      ...payload,
      ...params,
    }
    if (payload.startDate) {
      params.filters.push({
        searchby: 'created_at',
        searchoperator: '>',
        search: `${payload.startDate} 00:00:00`,
      })
    }
    if (payload.toDate) {
      params.filters.push({
        searchby: 'created_at',
        searchoperator: '<',
        search: `${payload.toDate} 23:59:59`,
      })
    }
    return Client.post(resource, params, {
      headers: {
        action: 'list-win-total',
      },
    })
  },
  show(payload) {
    const params = {
      ...payload,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'get-setting',
      },
    })
  },
  update(payload) {
    const params = {
      ...payload,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'update-setting',
      },
    })
  },
  pickWinner(payload) {
    const params = {
      ...payload,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'random-jackpot',
      },
    })
  },
  removeWinner(payload) {
    const params = {
      ...payload,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'remove-win-jackpot',
      },
    })
  },
  options(payload) {
    const params = prepareSearchParams({
      username: payload.search,
      searchFields: [
        { key: 'username' },
      ],
    })
    return Client.post(resource, params, {
      headers: {
        action: 'list-player-bet',
      },
    })
  },
}
